"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductTreeNodeWithChildren = void 0;
const react_1 = require("@apollo/client/react");
const gql_1 = require("../gql");
const useProductTreeNodeWithChildren = () => {
    const [getProductTreeNodeWithChildren, data] = (0, react_1.useLazyQuery)(gql_1.GET_PRODUCT_TREE_NODE_WITH_ONE_CHILD_LEVEL, {
        fetchPolicy: 'cache-first',
    });
    return Object.assign({ getProductTreeNodeWithChildren }, data);
};
exports.useProductTreeNodeWithChildren = useProductTreeNodeWithChildren;
exports.default = exports.useProductTreeNodeWithChildren;
